/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesRole } from './WebApiModelsEnumerationTypesRole';
import {
    WebApiModelsEnumerationTypesRoleFromJSON,
    WebApiModelsEnumerationTypesRoleFromJSONTyped,
    WebApiModelsEnumerationTypesRoleToJSON,
} from './WebApiModelsEnumerationTypesRole';

/**
 * 
 * @export
 * @interface WebApiCompanyDtoCompanyUserDto
 */
export interface WebApiCompanyDtoCompanyUserDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCompanyDtoCompanyUserDto
     */
    id?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesRole}
     * @memberof WebApiCompanyDtoCompanyUserDto
     */
    role?: WebApiModelsEnumerationTypesRole;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyUserDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyUserDto
     */
    inviteEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyUserDto
     */
    inviteId?: string | null;
}

/**
 * Check if a given object implements the WebApiCompanyDtoCompanyUserDto interface.
 */
export function instanceOfWebApiCompanyDtoCompanyUserDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCompanyDtoCompanyUserDtoFromJSON(json: any): WebApiCompanyDtoCompanyUserDto {
    return WebApiCompanyDtoCompanyUserDtoFromJSONTyped(json, false);
}

export function WebApiCompanyDtoCompanyUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCompanyDtoCompanyUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'role': !exists(json, 'role') ? undefined : WebApiModelsEnumerationTypesRoleFromJSON(json['role']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'inviteEmail': !exists(json, 'inviteEmail') ? undefined : json['inviteEmail'],
        'inviteId': !exists(json, 'inviteId') ? undefined : json['inviteId'],
    };
}

export function WebApiCompanyDtoCompanyUserDtoToJSON(value?: WebApiCompanyDtoCompanyUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'role': WebApiModelsEnumerationTypesRoleToJSON(value.role),
        'email': value.email,
        'name': value.name,
        'inviteEmail': value.inviteEmail,
        'inviteId': value.inviteId,
    };
}

